import dynamic from 'next/dynamic';
import type React from 'react';

// Interfaces
import type { Ranking } from 'interfaces/content/Ranking';

// Utils
import { UIFragments } from 'utils/log/constants/uiFragments';
import { AppErrorSeverity } from 'utils/log/constants/errorSeverity';

// Components
import ErrorBoundary from 'components/ErrorBoundary';

// Styles
import Title from './RankingsStyles';

const RankingsList = dynamic(() => import('components/RankingsList'));
const RankingsListItem = dynamic(() => import('components/RankingsList/RankingsListItem'));

export interface RankingsProps {
  rankings: Ranking[];
  title: string;
}

const RankingsPage: React.FC<RankingsProps> = ({ rankings, title }) => (
  <>
    <ErrorBoundary fragment={UIFragments.RANKING_PAGE}>
      <Title
        as='h1'
        $fontFamily='graphikCond'
        $size={{ default: 'level2', lgMin: 'xlarge', mdMin: 'large' }}
      >
        {title}
      </Title>
    </ErrorBoundary>
    <ErrorBoundary
      fragment={UIFragments.RANKING_PAGE}
      severity={AppErrorSeverity.HIGH}
    >
      <RankingsList>
        {rankings.map((ranking) => (
          <RankingsListItem
            key={ranking.franchiseListId}
            title={ranking.title}
            description={ranking.description}
            years={ranking.years}
            slug={ranking.slug}
            image={ranking.image}
            buttonTitle={ranking.buttonTitle}
            imageAlt={ranking.imageAlt}
            postId={ranking.postId}
            externalUrl={ranking.externalUrl}
            listTypeAlias={ranking.listTypeAlias}
            rank={null}
          />
        ))}
      </RankingsList>
    </ErrorBoundary>
  </>
);

export { RankingsPage };
